import React from "react";
import "./Topbrandssection.css";

import { img6, img7, img8, img9, img10, img11, img12, img13 } from "../index";

const Topbrandssection = () => {
  return (
    <div className="brands">
      <img class="avatar-round avatar-xxl" src={img6} alt="brand"></img>
      <img class="avatar-round avatar-xxl" src={img7} alt="brand"></img>
      <img class="avatar-round avatar-xxl" src={img8} alt="brand"></img>
      <img class="avatar-round avatar-xxl" src={img9} alt="brand"></img>
      <img class="avatar-round avatar-xxl" src={img10} alt="brand"></img>
      <img class="avatar-round avatar-xxl" src={img11} alt="brand"></img>
      <img class="avatar-round avatar-xxl" src={img12} alt="brand"></img>
      <img class="avatar-round avatar-xxl" src={img13} alt="brand"></img>
    </div>
  );
};

export default Topbrandssection;
